import { createContext } from "react";

import type { Context } from "react";

import type { SelectBoxContextValue } from "./selectBox.types";

export const DEFAULT_SELECT_BOX_CONTEXT_VALUE: SelectBoxContextValue = {
  changeSelectedItemRank: () => undefined,
  endRankEdit: () => undefined,
  libraryFilteredItems: [],
  multiSelectList: [],
  selectedFilteredItems: [],
  selectedItems: [],
  setMultiSelectList: () => undefined,
  setSelectedTab: () => undefined,
};

export const SelectBoxContext: Context<SelectBoxContextValue> =
  createContext<SelectBoxContextValue>(DEFAULT_SELECT_BOX_CONTEXT_VALUE);
